jQuery(document).ready(function ($) {
  let page = 1;
  let loading = false;

  // Update URL without duplicating the same URL
  function updateUrl(category = "", searchQuery = "", pageNum = 1) {
    const urlParams = new URLSearchParams(window.location.search);

    if (category) {
      urlParams.set("category", category);
    } else {
      urlParams.delete("category");
    }

    if (searchQuery) {
      urlParams.set("search", searchQuery);
    } else {
      urlParams.delete("search");
    }

    // Use a custom 'pageno' parameter instead of 'page'
    urlParams.set("pageno", pageNum);

    const newUrl = window.location.pathname + "?" + urlParams.toString();

    // Only update if the URL is different from the current one
    if (window.location.href !== newUrl) {
      // Use replaceState to avoid causing redirects
      history.replaceState(null, null, newUrl);
    }
  }

  // Restore state from the URL (when page loads or user navigates with the back button)
  function restoreStateFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const category = urlParams.get("category") || "";
    const searchQuery = urlParams.get("search") || "";
    const pageNum = parseInt(urlParams.get("pageno")) || 1; // Read 'pageno' instead of 'page'

    // Update the active category
    $("#blog-filter li").removeClass("active");
    if (category) {
      $("#blog-filter a[data-category='" + category + "']")
        .closest("li")
        .addClass("active");
    }

    // Reset posts container
    $("#send-posts-blog").html("");
    page = pageNum; // Set the page to the correct one based on the URL

    // Load posts from page 1 up to the current page
    function loadPages(i) {
      if (i <= pageNum) {
        fetchFilteredPosts(category, searchQuery, i);
        setTimeout(() => loadPages(i + 1), 100); // Delay between calls
      }
    }

    loadPages(1);
  }

  // Function to fetch posts with the current filters
  function fetchFilteredPosts(category, searchQuery, pageNum) {
    loading = true;
    $.ajax({
      type: "POST",
      url: ajax_object.ajaxurl,
      data: {
        action: "filter_posts",
        category,
        search: searchQuery,
        page: pageNum,
        nonce: ajax_object.nonce,
      },
      success: function (response) {
        if (pageNum === 1) {
          $("#send-posts-blog").html(response);
        } else {
          $("#send-posts-blog").append(response);
        }
        loading = false;
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", error);
        loading = false;
      },
    });
  }

  // Initial page load
  restoreStateFromUrl();

  // Handle category filter click
  $("#blog-filter a").click(function (e) {
    e.preventDefault();
    $("#blog-filter li").removeClass("active");
    $(this).closest("li").addClass("active");

    const category = $(this).data("category");
    const searchQuery = $("#search-input").val().trim();

    page = 1;
    updateUrl(category, searchQuery, page); // Update the URL
    fetchFilteredPosts(category, searchQuery, page); // Fetch the posts
  });

  // Handle load more button click
  $("#load-more-blog").click(function (e) {
    e.preventDefault();
    if (!loading) {
      page++;
      const urlParams = new URLSearchParams(window.location.search);
      const category = urlParams.get("category") || "";
      const searchQuery = urlParams.get("search") || "";
      updateUrl(category, searchQuery, page); // Update the URL with next page
      fetchFilteredPosts(category, searchQuery, page); // Fetch the next set of posts
    }
  });

  // Handle search input change
  $("#search-input").on("input", function () {
    const searchQuery = $(this).val().trim();
    const category = $("#blog-filter li.active a").data("category") || "";

    page = 1;
    updateUrl(category, searchQuery, page); // Update the URL with search query
    fetchFilteredPosts(category, searchQuery, page); // Fetch posts based on the new search
  });

  // Handle browser back button or manual URL changes
  window.onpopstate = function () {
    restoreStateFromUrl(); // Restore posts based on the current URL
  };

  /* MOBILE DROPDOWN FOR BUBBLE */
  // 1) Build bubble list from your existing desktop items (no event handlers copied)
  // Find the desktop UL robustly
  const $desktopUL = $(
    "#blog-filter .filters-desktop, #blog-filter > ul.flex, #blog-filter > ul"
  ).first();
  const $bubbleList = $("#blog-filter .bubble-list");

  // Quick sanity log
  // console.log("Found desktop items:", $desktopUL.find("li").length);

  // Clone ONLY the <li>s (no handlers)
  $desktopUL.children("li").clone(false, false).appendTo($bubbleList);

  // 2) Toggle menu
  const $toggle = $("#blog-filter .bubble-toggle");
  const $menu = $("#blog-filter .bubble-menu");
  $toggle.on("click", function () {
    const open = $menu.is(":hidden");
    $menu.prop("hidden", !open);
    $toggle.attr("aria-expanded", open);
  });
  $(document).on("click", function (e) {
    if (!$(e.target).closest("#blog-filter .filters-mobile").length) {
      $menu.prop("hidden", true);
      $toggle.attr("aria-expanded", "false");
    }
  });
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      $menu.prop("hidden", true);
      $toggle.attr("aria-expanded", "false");
    }
  });

  // 3) Proxy bubble clicks to your existing desktop links (reuses your current click handler)
  $("#blog-filter").on("click", ".bubble-list a", function (e) {
    e.preventDefault();
    const slug = $(this).data("category") || "";
    // Trigger the original handler you already bound to desktop anchors
    $desktopUL.find("a[data-category='" + slug + "']").trigger("click");
    // Update button label + close menu for UX
    $toggle.text("Filter: " + $(this).text().trim());
    $menu.prop("hidden", true);
    $toggle.attr("aria-expanded", "false");
  });

  // 4) Optional: keep the toggle label in sync when user clicks desktop links on small screens
  $("#blog-filter .filters-desktop a").on("click", function () {
    $toggle.text("Filter: " + $(this).text().trim());
  });
});

jQuery(function ($) {});
